import { Outlet } from "react-router-dom";

export default function PublicLayout() {
  return (
    <div className="min-h-dvh grid place-items-center p-6 bg-surface-primary dark:bg-gray-900">
      <Outlet />
    </div>
  );
}
